import { dateFormats } from 'commons/src/constants';
import { emptyAction, PublicActions, PublicActionType } from '../actions';
import { localStorageKeyNumberOfTilesInWidth, minScreenWidthNumberOfTiles } from '../constants';

export type PublicUserPreferencesStore = {
    measurementSystem: 'METRIC' | 'US';
    dateFormat: keyof typeof dateFormats;
    numberOfTilesInWidth: number;
};

const setNumberOfTiles = (width: number) => {
    localStorage.setItem(localStorageKeyNumberOfTilesInWidth, width.toString());
    return width;
};

const getNumberOfTiles = (): number => {
    const numberOfTilesSet = localStorage.getItem(localStorageKeyNumberOfTilesInWidth);
    const windowSize = document.documentElement.clientWidth;
    const recommendedWindowSizeLessThan = Object.keys(minScreenWidthNumberOfTiles).find(
        widthOption => minScreenWidthNumberOfTiles[widthOption as keyof typeof minScreenWidthNumberOfTiles] > windowSize
    );
    let recommendedWindowSize = 4;
    if (recommendedWindowSizeLessThan) {
        const recommendedAsNumber = parseInt(recommendedWindowSizeLessThan, 10);
        recommendedWindowSize = recommendedAsNumber > 1 ? recommendedAsNumber - 1 : 1;
    }

    if (numberOfTilesSet) {
        const numberOfTilesSetToNumber = parseInt(numberOfTilesSet, 10);
        const tileWidth =
            recommendedWindowSize < numberOfTilesSetToNumber ? recommendedWindowSize : numberOfTilesSetToNumber;
        return setNumberOfTiles(tileWidth);
    }

    return setNumberOfTiles(recommendedWindowSize);
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const userLanguage = window.navigator.language || window.navigator.userLanguage;
const initialState: PublicUserPreferencesStore = {
    measurementSystem: 'METRIC',
    dateFormat:
        userLanguage.toLowerCase() === 'en-us'
            ? (dateFormats.US.type as keyof typeof dateFormats)
            : (dateFormats.EUR.type as keyof typeof dateFormats),
    numberOfTilesInWidth: 2,
};

export default (state = initialState, action: PublicActions = emptyAction) => {
    switch (action.type) {
        case PublicActionType.FetchUserPreferencesSuccess:
            return {
                ...state,
                measurementSystem: action.payload.measurementSystem,
                dateFormat: action.payload.measurementSystem === 'US' ? dateFormats.US.type : dateFormats.EUR.type,
                numberOfTilesInWidth: action.payload.tilesInWidth
                    ? parseInt(action.payload.tilesInWidth, 10)
                    : getNumberOfTiles(),
            };
        case PublicActionType.SetNumberOfTilesInWidth:
            return {
                ...state,
                numberOfTilesInWidth: setNumberOfTiles(action.width),
            };
        default:
            return state;
    }
};
